import Logger from './Logger';

interface FormatErrorMessageProps {
  errorMessage: string;
  defaultErrorMessage: string;
  errorMessageMap: Record<string, string>;
}

export const formatErrorMessage = ({ errorMessage, defaultErrorMessage, errorMessageMap }: FormatErrorMessageProps) => {
  const formattedErrorMessage = Object.entries(errorMessageMap)
    .find(([key]) => errorMessage.includes(key))?.[1];

  if (!formattedErrorMessage) {
    Logger.error('Unknown error', {
      error: errorMessage,
    });

    return defaultErrorMessage;
  }

  return formattedErrorMessage;
};
